import {reactive} from "vue";
import parseJson from "@/parse-json";
import {BackendFetch} from "@hantera/portal-app";

export interface PhraseTemplate {
  /**
   * @key language key
   * @value translation
   */
  translations: Record<string, string>
  context: string
  template: string
}

const phrases = reactive<Record<number, PhraseTemplate>>({});

function hashString(str: string): number {
  let h1 = 0;
  let h2 = 0;
  let len = str.length;
  let seed = 0x2f;

  for (let i = 0, j = len; i < len; i++, j--) {
    h1 ^= str.charCodeAt(i) * seed;
    h1 = Math.imul(h1, 0x5bd1e995);
    h1 ^= h1 >>> 24;

    h2 ^= str.charCodeAt(j - 1) * seed;
    h2 = Math.imul(h2, 0x5bd1e995);
    h2 ^= h2 >>> 24;
  }

  h1 = Math.imul(h1 ^ h2, 0x5bd1e995);
  h1 ^= h1 >>> 13;
  h1 = Math.imul(h1, 0x5bd1e995);
  h1 ^= h1 >>> 15;

  return h1 >>> 0;
}

export default function (portalFetch: BackendFetch) {

  return {
    get(context: string[], template: string, languages: string[]) {
      template = template.trim();
      
      if (template.length === 0) {
        return '';
      }
      
      const hash = hashString([...context, template].join('.'));

      const existing = phrases[hash];
      if (typeof existing === 'undefined') {
        const newMessage: Record<number, PhraseTemplate> = {};
        newMessage[hash] = {
          context: context.join('.'),
          template,
          translations: {}
        };
        Object.assign(phrases, newMessage);

        portalFetch('/phrases', {
          method: 'POST',
          body: JSON.stringify({
            hash,
            context: context.join('.'),
            template,
          }),
        });

        return template;
      }

      while (languages.length > 0) {
        let language = languages[0];
        if (existing.translations?.[language] !== undefined) {
          return existing.translations[language];
        }
        languages = languages.slice(1);
      }

      return template;
    },
    value: phrases,
    async refresh() {
      const res = await portalFetch('/phrases', {
        method: 'GET'
      });

      if (res.status === 200) {
        const fetched: Record<number, PhraseTemplate> = {};

        (parseJson(await res.text()) as {
          hash: number
          context: string
          template: string
          translations: {
            [lang: string]: string
          }
        }[]).forEach(msg => {
          fetched[msg.hash] = {
            translations: msg.translations,
            context: msg.context,
            template: msg.template,
          };
        });

        Object.assign(phrases, fetched);
      }
    }

  };
}